export default __webpack_public_path__ + "static/media/tooltip-check-outline.bf2a7363.svg";